export default function() {
    (function($) {
        let header,
            adminBar,
            adminbarHeight,
            headerHeight,
            fixedPageHeaderOffset = 0;

        function updateFixedHeaderVariables() {
            // reset before updating value
            fixedPageHeaderOffset = 0;

            window.MG_giafWWDataTableFixWithJs = false;

            if (!window.CSS || !window.CSS.supports('position', 'sticky')) {
                window.MG_giafWWDataTableFixWithJs = true;
            } else {
                window.MG_giafWWDataTableFixWithJs = !window.matchMedia(
                    '(min-width: 1400px)'
                ).matches;
            }

            if (header) {
                headerHeight = header.getBoundingClientRect().height;
                fixedPageHeaderOffset += headerHeight;
            }

            if (adminBar) {
                adminbarHeight = adminBar.getBoundingClientRect().height;
                fixedPageHeaderOffset += adminbarHeight;
            }

            fixedPageHeaderOffset = Math.floor(fixedPageHeaderOffset);
        }

        function fixGIAFworldwideTableHead() {
            const table = window.MG_GiafWWDataTable;

            let thead,
                tableFromViewPortTop,
                lastTbodyRow,
                lastTbodyRowHeight,
                translateValue = null,
                translateYValue = 0;

            if (!table) return;

            thead = window.MG_GiafWWDataTableThead;
            lastTbodyRow = window.MG_GiafWWDataTableLastTbodyRow;

            tableFromViewPortTop = table.getBoundingClientRect().top;
            lastTbodyRowHeight = lastTbodyRow.getBoundingClientRect().height;

            table.style.setProperty(
                '--headerHeight',
                `${fixedPageHeaderOffset}px`
            );

            table.style.setProperty(
                '--lastRowHeight',
                `${lastTbodyRowHeight}px`
            );

            if (!window.MG_giafWWDataTableFixWithJs) {
                // using position: sticky in this case so do not apply translate,
                // Not using position: sticky in more narrow viewports becuase the data table scrolls horizontally
                // position: sticky will not work as desired once table beings scrolling horizontally
                translateValue = `translateY( 0px )`;
            } else if (tableFromViewPortTop >= fixedPageHeaderOffset) {
                translateYValue = 0;
            } else {
                const fixedElms =
                    fixedPageHeaderOffset +
                    thead.getBoundingClientRect().height;
                const lastTbodyRowFromViewportTop = lastTbodyRow.getBoundingClientRect()
                    .top;

                if (lastTbodyRowFromViewportTop <= fixedElms) {
                    translateYValue =
                        table.getBoundingClientRect().height -
                        lastTbodyRowHeight;

                    translateValue = `translateY( calc(-100% + ${translateYValue}px) )`;
                } else {
                    if (tableFromViewPortTop < 0) {
                        translateYValue =
                            fixedPageHeaderOffset + tableFromViewPortTop * -1;
                    } else {
                        translateYValue =
                            fixedPageHeaderOffset - tableFromViewPortTop;
                    }

                    translateValue = `translateY( ${translateYValue}px )`;
                }
            }

            thead.style.transform = translateValue;
        }

        $(function() {
            header = document.querySelector('#masthead');
            adminBar = document.querySelector('#wpadminbar');

            updateFixedHeaderVariables();
            fixGIAFworldwideTableHead();

            $(window).on('resize', function() {
                updateFixedHeaderVariables();
                fixGIAFworldwideTableHead();
            });

            $(window).scroll(function() {
                fixGIAFworldwideTableHead();
            });
        });
    })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/tables.js